



















import { dayjs, DT_FORMAT_INPUT, MONTH_FORMAT } from '../../../src_server/common/momentExtends';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { DailyReportService } from '../../biz/remote/DailyReportService';
import { ReportEvaluateDTO } from '../../../src_server/entity/dto/ReportEvaluateDTO';
import { TableColumn } from 'src_client/components/organisms/CommonTable.vue';

@Component({ components: {} })
export default class ReportAnaliticsPage extends Vue {
  private month = dayjs().format(MONTH_FORMAT);
  private value: ReportEvaluateDTO[] = [];

  public cols: TableColumn[] = [
    { label: 'No', type: 'seq' },
    { label: 'ID', name: 'teacher.user_id' },
    { label: '名前', name: 'teacher.nickname' },
    { label: '平均', name: 'star_avg' },
    { label: 'レッスン数', name: 'lesson_count' },
    { label: '合計評価ポイント', name: 'sum_star' },
  ];

  nextMonth() {
    this.month = dayjs(this.month).add(1, 'month').format(MONTH_FORMAT);
  }
  currentMonth() {
    this.month = dayjs().format(MONTH_FORMAT);
  }
  prevMonth() {
    this.month = dayjs(this.month).add(-1, 'month').format(MONTH_FORMAT);
  }

  @Watch('month')
  async loadData() {
    const biz = new DailyReportService();
    const firstDt = dayjs(this.month).startOf('month').format(DT_FORMAT_INPUT);
    const endDt = dayjs(this.month).endOf('month').format(DT_FORMAT_INPUT);
    const response = await biz.getTeachersReportAnalitics(firstDt, endDt, Session.getSessionBuildingId());
    this.value = response.data;
  }

  async created() {
    this.loadData();
  }
}
